import { createSelector } from '@ngrx/store';
import { State } from '@store/state';
import { NotificationListEmailSmsState } from './notification-list-email-sms.reducer';

const getNotificationListEmailSmsState = (state: State) => state.notificationListEmailSms;

export const getPublicEmailProductIdsEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.publicEmailProductIds.data
);

export const getNotificationsEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notification
);

export const getNotificationListEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notification.data
);

export const getNotificationFiltersEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notification.filters
);

export const getEventTypesForProductIdEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) =>
    Object.fromEntries(
      Object.entries(state.eventTypesByProductId).map(([productId, apiCall]) => [productId, apiCall.data ?? []])
    )
);

export const getEventTypesErrorsEmailSms = (productIds: string[]) => createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => {
    const errors = productIds
      .map((productId) => state.eventTypesByProductId[productId]?.error)
      .filter((error): error is string => error != null);
    return errors.length > 0 ? errors.join(', ') : null;
  }
);

export const isNotificationLoadingEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notification.isLoading
);

export const getNotificationErrorEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notification.error
);

export const getNotificationPaginationEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notificationPagination
);

export const getNotificationCurrentPageNumberEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notificationPagination.currentPageNumber
);

export const getNotificationTotalPagesEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notificationPagination.totalPages
);

export const getNotificationTotalNotificationsEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notificationPagination.totalNotifications
);

export const getNotificationPageSizeEmailSms = createSelector(
  getNotificationListEmailSmsState,
  (state: NotificationListEmailSmsState) => state.notificationPagination.pageSize
);
